














import { Vue, Component, Prop} from "vue-property-decorator";

import DevicesTest from "@share/web-conferences/components/devices-test/DevicesTest.vue";
import QualityTest from "@share/web-conferences/components/quality-test/QualityTest.vue";
import AgoraDeviceTestStart from "@share/common/agora-device-test/AgoraDeviceTestStart.vue";

@Component({
    components: {AgoraDeviceTestStart, DevicesTest, QualityTest }
})

export default class AgoraDeviceTest extends Vue {
    @Prop({ default: false }) startButtonExist: boolean;

    isStarted = false;
}
